import moment from "moment";
import { VerificationNames, DataVendors } from "shared/types";
import { getLogoSrc } from "../../../utils/getLogoSrc";

type ReportCompletedBannerProps = {
  completedAt?: string;
  reportId?: string;
  verificationName: VerificationNames;
  vendor?: DataVendors;
};

export const ReportCompletedBanner = ({
  completedAt,
  reportId,
  verificationName,
  vendor
}: ReportCompletedBannerProps) => {
  const dataVendor = vendor || verificationName;
  const src = getLogoSrc(dataVendor);
  return (
    <div className="pt-2 pb-6">
      <div className="flex relative">
        <div className="space-y-2">
          <p className="text-sm text-content-1000 font-medium mr-auto">
            Report was successfully completed
            {completedAt
              ? ` on ${moment(completedAt).format("MMM D, YYYY, [at] h:mm A")}`
              : ""}
          </p>
          <div className="md:absolute right-0 top-0">
            {src ? (
              <img
                src={src}
                alt={`Provider ${verificationName}`}
                className={
                  dataVendor === DataVendors.TransUnion ? "h-9 -mt-2" : ""
                }
              />
            ) : null}
          </div>

          {reportId ? (
            <p className="text-content-300 text-xs font-medium">
              Report ID: {reportId}
            </p>
          ) : null}
        </div>
      </div>

      {/* -mx-6 makes it wider than container */}
      <div className="-mx-6 mt-6 border-b border-alpha-40"></div>
    </div>
  );
};
